'use client';

import _defineProperty from "/codebuild/output/src3339/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src3339/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["classNames", "className", "style", "styles", "unstyled", "vars", "yOffset", "scrollAreaComponent", "radius", "fullScreen", "centered", "xOffset", "__staticSelector"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { rem } from '../../core/utils/units-converters/rem.mjs';
import 'react';
import { getDefaultZIndex } from '../../core/utils/get-default-z-index/get-default-z-index.mjs';
import { getRadius, getSize } from '../../core/utils/get-size/get-size.mjs';
import '@mantine/hooks';
import { createVarsResolver } from '../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { useStyles } from '../../core/styles-api/use-styles/use-styles.mjs';
import '../../core/Box/Box.mjs';
import { factory } from '../../core/factory/factory.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import { ModalBase } from '../ModalBase/ModalBase.mjs';
import '../ModalBase/ModalBaseBody.mjs';
import '../ModalBase/ModalBaseCloseButton.mjs';
import '../ModalBase/ModalBaseContent.mjs';
import '../ModalBase/ModalBaseHeader.mjs';
import '../ModalBase/ModalBaseOverlay.mjs';
import '../ModalBase/ModalBaseTitle.mjs';
import { ModalProvider } from './Modal.context.mjs';
import classes from './Modal.module.css.mjs';
var defaultProps = {
  __staticSelector: "Modal",
  closeOnClickOutside: true,
  withinPortal: true,
  lockScroll: true,
  trapFocus: true,
  returnFocus: true,
  closeOnEscape: true,
  keepMounted: false,
  zIndex: getDefaultZIndex("modal"),
  transitionProps: {
    duration: 200,
    transition: "pop"
  },
  yOffset: "5dvh"
};
var varsResolver = createVarsResolver(function (_, _ref) {
  var radius = _ref.radius,
    size = _ref.size,
    yOffset = _ref.yOffset,
    xOffset = _ref.xOffset;
  return {
    root: {
      "--modal-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--modal-size": getSize(size, "modal-size"),
      "--modal-y-offset": rem(yOffset),
      "--modal-x-offset": rem(xOffset)
    }
  };
});
var ModalRoot = factory(function (_props, ref) {
  var props = useProps("ModalRoot", defaultProps, _props);
  var classNames = props.classNames,
    className = props.className,
    style = props.style,
    styles = props.styles,
    unstyled = props.unstyled,
    vars = props.vars,
    yOffset = props.yOffset,
    scrollAreaComponent = props.scrollAreaComponent,
    radius = props.radius,
    fullScreen = props.fullScreen,
    centered = props.centered,
    xOffset = props.xOffset,
    __staticSelector = props.__staticSelector,
    others = _objectWithoutProperties(props, _excluded);
  var getStyles = useStyles({
    name: __staticSelector,
    classes: classes,
    props: props,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    unstyled: unstyled,
    vars: vars,
    varsResolver: varsResolver
  });
  return /* @__PURE__ */jsx(ModalProvider, {
    value: {
      yOffset: yOffset,
      scrollAreaComponent: scrollAreaComponent,
      getStyles: getStyles,
      fullScreen: fullScreen
    },
    children: /* @__PURE__ */jsx(ModalBase, _objectSpread(_objectSpread({
      ref: ref
    }, getStyles("root")), {}, {
      "data-full-screen": fullScreen || void 0,
      "data-centered": centered || void 0,
      unstyled: unstyled
    }, others))
  });
});
ModalRoot.classes = classes;
ModalRoot.displayName = "@mantine/core/ModalRoot";
export { ModalRoot };